import { Tag } from 'antd';
import type { UpdatableSegmentStatus } from 'business/receipt/constants';
import { cn } from 'technical/tailwind/cn';
import { useTranslation } from 'translations/hooks';

export const StatusTag = ({ status }: { status: UpdatableSegmentStatus }) => {
  const { t } = useTranslation();

  const statusClasses = {
    ACCEPTED: 'bg-blue-100 text-blue-700 border-blue-200',
    ON_HOLD: 'bg-grey-100 text-grey-700 border-grey-200',
    REJECTED: 'bg-red-100 text-red-700 border-red-200',
    QUARANTINE: 'bg-orange-100 text-orange-700 border-orange-200',
  } satisfies Record<UpdatableSegmentStatus, string>;

  return (
    <Tag className={cn('rounded-[10px]', statusClasses[status])}>
      <span className="mr-1 leading-none">&#x25CF; </span>
      {t(`chooseSegmentStatus.status.state`, { context: status })}
    </Tag>
  );
};
